module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [(_vm.newCityDestiny || !this.dataLocal.dataShipment.status) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "formItem"
  }, [(!this.dataLocal.dataShipment.status && _vm.currentUserRole == 'Admin') ? _c('div', [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Operador de envío")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCreatorOperator),
      expression: "newCreatorOperator"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "destiny_city"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCreatorOperator = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listSenderOperators), function(operator) {
    return _c('option', {
      domProps: {
        "value": operator
      }
    }, [_vm._v(_vm._s(operator.attributes.username))])
  })], 2), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('creator_operator')),
      expression: "errors.has('creator_operator')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('creator_operator')))]), _vm._v(" "), (_vm.origin_id !== 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Origen")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(_vm.origin_id === 2) ? _c('input', {
    staticClass: "form-control block",
    attrs: {
      "type": "text",
      "id": "exampleInputEmail1",
      "value": "Miami",
      "readonly": "readonly"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.origin_id === 12) ? _c('input', {
    staticClass: "form-control block",
    attrs: {
      "type": "text",
      "id": "exampleInputEmail1",
      "value": "Buenos Aires",
      "readonly": "readonly"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.origin_id === 22) ? _c('input', {
    staticClass: "form-control block",
    attrs: {
      "type": "text",
      "id": "exampleInputEmail1",
      "value": "Lima",
      "readonly": "readonly"
    }
  }) : _vm._e()])]) : _vm._e()])]) : (this.dataLocal.dataShipment.status && _vm.currentUserRole == 'Admin') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Operador de envío")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('p', {
    staticClass: "form-control block"
  }, [_vm._v(_vm._s(_vm.newCreatorOperator.attributes.username))])])]) : _vm._e(), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Destino")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCityDestiny),
      expression: "newCityDestiny"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "destiny_city"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCityDestiny = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listCities), function(cityOrigin) {
    return _c('option', {
      domProps: {
        "value": cityOrigin
      }
    }, [_vm._v(_vm._s(cityOrigin.attributes.name))])
  })], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destiny_city')),
      expression: "errors.has('destiny_city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('destiny_city')))])])])]) : (this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Destino")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('p', {
    staticClass: "form-control block"
  }, [_vm._v(_vm._s(_vm.newCityDestiny.attributes.name))])])])]) : _vm._e(), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDescription),
      expression: "newDescription"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "name": "description_shipment",
      "rows": "3",
      "cols": "70",
      "maxlength": 500
    },
    domProps: {
      "value": (_vm.newDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDescription = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('description_shipment')),
      expression: "errors.has('description_shipment')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('description_shipment')))])])])]) : (this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('p', {
    staticClass: "form-control block",
    model: {
      value: (_vm.newDescription),
      callback: function($$v) {
        _vm.newDescription = $$v
      },
      expression: "newDescription"
    }
  }, [_vm._v(_vm._s(_vm.dataLocal.dataShipment.description))])])])]) : _vm._e(), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de salida")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDateDeparture),
      expression: "newDateDeparture"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "name": "departure_date",
      "max": "2100-12-31"
    },
    domProps: {
      "value": (_vm.newDateDeparture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDateDeparture = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('departure_date')),
      expression: "errors.has('departure_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('departure_date')))])])])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha y hora de salida")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('p', {
    staticClass: "form-control block"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.newDateDeparture)))])])])]), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Hora de salida")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newHourDeparture),
      expression: "newHourDeparture"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "time",
      "name": "departure_hour"
    },
    domProps: {
      "value": (_vm.newHourDeparture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newHourDeparture = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('departure_hour')),
      expression: "errors.has('departure_hour')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('departure_hour')))])])])]) : _vm._e(), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDateArrival),
      expression: "newDateArrival"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "name": "arrival_date",
      "max": "2100-12-31"
    },
    domProps: {
      "value": (_vm.newDateArrival)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDateArrival = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('arrival_date')),
      expression: "errors.has('arrival_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('arrival_date')))])])])]) : _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('p', {
    staticClass: "form-control block"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.newDateArrival)))])])])]), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Hora de llegada")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newHourArrival),
      expression: "newHourArrival"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "time",
      "name": "arrival_hour"
    },
    domProps: {
      "value": (_vm.newHourArrival)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newHourArrival = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('arrival_hour')),
      expression: "errors.has('arrival_hour')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('arrival_hour')))])])])]) : _vm._e(), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Operador de llegada")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newRecieverOperator),
      expression: "newRecieverOperator"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "reciever_operator"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newRecieverOperator = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listOperatorReciever), function(operator) {
    return _c('option', {
      domProps: {
        "value": operator
      }
    }, [_vm._v(_vm._s(operator.attributes.username) + " ")])
  })], 2), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('reciever_operator')),
      expression: "errors.has('reciever_operator')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('reciever_operator')))])])])]) : _vm._e(), _vm._v(" "), (_vm.newRecieverOperator && this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Operador de llegada")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('p', {
    staticClass: "form-control block"
  }, [_vm._v(_vm._s(_vm.newRecieverOperator.attributes.profile.attributes.name) + " " + _vm._s(_vm.newRecieverOperator.attributes.profile.attributes.surnames))])])])]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.toNextForm
    }
  }, [_vm._v("Crear Embarque")])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    ref: "validacionmodal",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "validacionmodal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModalValidation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-correcto text-center"
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [_c('h1')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": _vm.hideModalValidation
    }
  }, [_vm._v("Continuar")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formContent"
  }, [_c('h1', [_vm._v("Datos del embarque")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Es el operador de envío al que se le asigna el embarque")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Es la ciudad destino del embarque")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Fecha de salida del vuelo del embarque desde la ciudad de origen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Hora de salida del vuelo del embarque desde la ciudad de origen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de llegada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Fecha de llegada del vuelo del embarque a la ciudad destino")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha y hora de llegada "), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Hora de llegada del vuelo del embarque a la ciudad origen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Es el operador que está en el destino, al que se le asigna el embarque")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48d89552"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/elements/form-1-create-shipment.vue
// module id = 1875
// module chunks = 1